export const FETCH_USERS = "management/users/all";
export const CREATE_USER = "management/users/create";
export const GET_CURRENT_USER = "management/users/current-user";
export const DELETE_USER = (id) => `management/users/delete/${id}`;
